import ky from 'ky';
import { z } from 'zod';
import { ENV } from 'src/utils/env';
import { getHeadersWithBearerToken } from 'src/utils/get-auth-with-bearer';

const DEVICES_BY_SIM_CARD_ID_SCHEMA = z.array(
  z.object({
    uuid: z.string(),
    organisations: z.string().array(),
  })
);

// returns null when no device is using the sim
export const getDeviceBySimCardIdPromise = async (simCardId: string) => {
  const headers = getHeadersWithBearerToken();

  const response = await ky
    .get(`${ENV.API_URL}/api/displays/`, {
      headers,
      searchParams: { sim_card_id: simCardId },
    })
    .json();
  const res = DEVICES_BY_SIM_CARD_ID_SCHEMA.safeParse(response);

  if (!res.success) {
    console.error('Error fetching device by sim card id:', res.error.message);
    throw new Error('Error fetching device for sim');
  }

  return res.data[0] ?? null;
};
